import ReactDOM from 'react-dom/client';

import initSentry from './util/sentry';
import Root from './Root';

initSentry();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Root />);
